export enum TextFieldSize {
  SMALL = 'small',
  DEFAULT = 'default'
}

export enum TextFieldType {
  TEXT = 'text',
  NUMBER = 'number',
  PASSWORD = 'password',
  EMAIL = 'email',
  PHONE = 'tel',
}
